import { useState, useEffect } from 'react';
import { getState, subscribe } from '../store';

export function useStore() {
  const [, setTick] = useState(0);
  useEffect(() => {
    return subscribe(() => setTick((t) => t + 1));
  }, []);
  return getState();
}